export default __webpack_public_path__ + "static/media/web.800d3612.png";